// Saves CSV text built by the API (an export) as a file named `filename`.
export function saveCsv(csv, filename) {
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Some browsers start the download after click() returns; free the URL a moment later.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// The file name from an attachment's Content-Disposition header, or `fallback`.
export function attachmentFilename(headers, fallback) {
  const match = /filename="([^"]+)"/.exec((headers && headers['content-disposition']) || '');
  return match ? match[1] : fallback;
}
